<script>
import moment from 'moment'
import {
  RexInput,
  RexDate,
  RexSelect,
  RexRadioGroup
} from '@/components/views/rexFieldsV2'

export default {
  name: 'tourists-form',
  components: {
    RexRadioGroup,
    RexInput,
    RexDate,
    RexSelect
  },
  props: {},
  computed: {
    getTouristsForm() {
      return this.$store.getters['cart/getTouristsForm']
    },
    countries() {
      return this.$store.getters.getDictionary('cart.dictionaries.countries')
    },
    datepickersRange: () => ({
      minDate: moment().subtract(100, 'years').toDate(),
      maxDate: moment().toDate(),
    })
  },
  inject: ['$validator'],
  methods: {
    moment,
    onChangeCitizen(touristIndex) {
      this.$store.dispatch('getDictionary', {
        params: {
          ...this.$store.getters['cart/getDocumentsParams'](touristIndex)
        },
        config: {
          dictionaryName: 'documents',
          target: `cart.touristsForm.${touristIndex}.documents`
        }
      })
    }
  }
}
</script>

<template>
  <div class="cart__form">
    <div class="cart__form--header">
      <h2>Данные о туристах</h2>
      <span>Все поля обязательны для заполнения</span>
    </div>
    <div
      v-for="(tourist, index) in getTouristsForm"
      :key="tourist.id"
      class="cart__form--item cart__form-item"
    >
      <div class="cart__form-item--row cart__form-item--header">
        <h2>Турист {{ index + 1 }}</h2>
        <rex-radio-group
          :name="`gender${tourist.id}`"
          store-module="cart"
          getter="getServiceField"
          setter="updateServiceField"
          :target="`touristsForm.${tourist.id}.gender`"
          :validate="{
            required: true
          }"
          class="cart__form-item--gender"
          :show-label="false"
          :options="[
            {
              slug: 'm',
              name: 'Мужской'
            },
            {
              slug: 'f',
              name: 'Женский'
            }
          ]"
        />
      </div>
      <div class="cart__form-tourists">
        <rex-input
          label="Фамилия"
          :name="`surname${tourist.id}`"
          store-module="cart"
          getter="getServiceField"
          setter="updateServiceField"
          :target="`touristsForm.${tourist.id}.surname`"
          :validate="{
            required: true
          }"
          placeholder="IVANOV"
          :is-uppercase="true"
        />
        <rex-input
          label="Имя"
          :name="`name${tourist.id}`"
          store-module="cart"
          getter="getServiceField"
          setter="updateServiceField"
          :target="`touristsForm.${tourist.id}.name`"
          :validate="{
            required: true
          }"
          placeholder="IVAN"
          :is-uppercase="true"
        />
        <rex-input
          label="Отчество"
          :name="`middleName${tourist.id}`"
          store-module="cart"
          getter="getServiceField"
          setter="updateServiceField"
          :target="`touristsForm.${tourist.id}.middleName`"
          :validate="{
            required: true
          }"
          placeholder="IVANOVICH"
          :is-uppercase="true"
        />
        <rex-date
          label="Дата рождения"
          :name="`birthday${tourist.id}`"
          store-module="cart"
          getter="getServiceField"
          setter="updateServiceField"
          :target="`touristsForm.${tourist.id}.birthday`"
          :min-date="moment().subtract(100, 'years').toDate()"
          :max-date="moment().toDate()"
          :years-range="[-50, +50]"
          :validate="{
            required: true
          }"
        />
      </div>
      <div class="cart__form-tourists">
        <rex-select
          label="Гражданство"
          :name="`citizen${tourist.id}`"
          store-module="cart"
          getter="getServiceField"
          setter="updateServiceField"
          :target="`touristsForm.${tourist.id}.citizen`"
          :validate="{
            required: true
          }"
          placeholder="Выберите гражданство"
          :options="countries"
          @change="onChangeCitizen(index)"
        />
        <rex-select
          label="Тип документа"
          :name="`documentType${tourist.id}`"
          store-module="cart"
          getter="getServiceField"
          setter="updateServiceField"
          :target="`touristsForm.${tourist.id}.documentType`"
          :validate="{
            required: true
          }"
          :hide-if-empty="false"
          :is-disabled="tourist.documents.length === 0"
          :options="tourist.documents"
          placeholder="Выберите документ"
        />
        <rex-input
          label="Номер документа"
          :name="`documentNumber${tourist.id}`"
          store-module="cart"
          getter="getServiceField"
          setter="updateServiceField"
          :target="`touristsForm.${tourist.id}.documentNumber`"
          :validate="{
            required: true
          }"
        />
        <rex-date
          label="Действует до"
          :name="`expirationDate${tourist.id}`"
          store-module="cart"
          getter="getServiceField"
          setter="updateServiceField"
          :target="`touristsForm.${tourist.id}.expirationDate`"
          :years-range="[-50, +50]"
          :validate="{
            required: true
          }"
        />
      </div>
      <div class="cart__form-item--row">
        <rex-text
          label="Телефон"
          :name="`phone${tourist.id}`"
          store-module="cart"
          getter="getServiceField"
          setter="updateServiceField"
          :target="`touristsForm.${tourist.id}.phone`"
          :validate="{
            required: true
          }"
          placeholder="+X XXX XXX XX XX"
          type="tel"
        />
        <rex-text
          label="Почта"
          :name="`email${tourist.id}`"
          store-module="cart"
          getter="getServiceField"
          setter="updateServiceField"
          :target="`touristsForm.${tourist.id}.email`"
          :validate="{
            required: true,
            email: true
          }"
          placeholder="ivanov@mail.com"
          type="email"
        />
      </div>
    </div>
  </div>
</template>